import type { ContentWithImageProps } from "modules/sections/ContentWithImage";
import { ContentWithImage } from "modules/sections/ContentWithImage";
import type { ReactStoryblokComponent } from "types/storyblok";

const ContentWithImageSection = ({
  blok: {
    srcMobile,
    srcDesktop,
    alt,
    reverseColumns,
    components,
    bgMobile,
    isIllustration,
    illustrationSizeMobile,
    illustrationAlignMobile,
    ptMobile,
    ptTablet,
    ptDesktop,
    pbMobile,
    pbTablet,
    pbDesktop,
    px,
  },
  sbEditable,
}: ReactStoryblokComponent<ContentWithImageProps>) => (
  <ContentWithImage
    srcMobile={srcMobile}
    srcDesktop={srcDesktop}
    alt={alt}
    components={components}
    reverseColumns={reverseColumns}
    bgMobile={bgMobile}
    isIllustration={isIllustration}
    ptMobile={ptMobile}
    ptTablet={ptTablet}
    ptDesktop={ptDesktop}
    pbMobile={pbMobile}
    pbTablet={pbTablet}
    pbDesktop={pbDesktop}
    px={px}
    sbEditable={sbEditable}
    illustrationSizeMobile={illustrationSizeMobile}
    illustrationAlignMobile={illustrationAlignMobile}
  />
);

export { ContentWithImageSection };
